import { useTranslation } from "react-i18next";
import "./QdsSignatureCard.style.css";
import { QdsSignatureCardInfoProps } from "../QdsSignatures.types";

export const QdsSignatureCardInfo = ({ qdsRequest }: QdsSignatureCardInfoProps) => {
  const { t } = useTranslation();

  if (!qdsRequest) {
    return null;
  }

  // Format created date to dd.MM.yyyy
  const formatDate = (date: string | Date | undefined): string => {
    if (!date) return "N/A";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const createdDate = formatDate(qdsRequest.createdAt);

  return (
    <div className="qds-card-info-content">
      <div className="qds-card-info-item">
        <div className="qds-card-info-label">{t("TABLE.NAME")}</div>
        <div className="qds-card-info-value">{qdsRequest.documentName}</div>
      </div>
      <div className="qds-card-info-item">
        <div className="qds-card-info-label">Created On</div>
        <div className="qds-card-info-value">{createdDate}</div>
      </div>
    </div>
  );
};
